import {
  IBranchState
} from "./types";
export const initialState: IBranchState = {
  preBookingQuestions: []
};
